export default "__VITE_ASSET__ae1d87c8__"